/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $WorkflowStepId = {
  type: 'Enum',
} as const;
